module.exports = __webpack_public_path__ + "img/1728955614460-Screenshot_15-10-2024_92641_www.instagram.com.jpeg.ee185125.webp";